import { graphql } from 'gatsby';
import { IconsList } from "../../../../src/components/icons-list";
import { P } from "../../../../src/components/Typography";
import * as React from 'react';
export default {
  graphql,
  IconsList,
  P,
  React
};